import { Card, Col, Input, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import ParListSelect from 'components/ParListSelect';
import { getThirdPartyById } from 'services/thirdParty';
import { useQuery } from 'react-query';

// import '@ant-design/compatible/assets/index.css';










export type TabTPBankAccountProps = {
  objectid?: number;
  form?: FormInstance;
  setSuccessful: any;
};

const TabTPBankAccount = ({
  objectid,
  form,
  setSuccessful,
}: TabTPBankAccountProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState<any>({
    bankAccount: {},
    generalData: {},
  });

  const { data, refetch, isFetching } = useQuery(
    ['getThirdPartyById', { tpid: objectid }],
    () => getThirdPartyById({ tpid: objectid! }).then((res) => res.data),
    { enabled: false }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (data) {
      const { bankAccount } = data;

      form?.setFieldsValue({
        tpbankname: bankAccount?.tpbankname,
        tpbic: bankAccount?.tpbic,
        tpcbdate: bankAccount?.tpcbdate,
        tpcbkey: bankAccount?.tpcbkey,
        tpcbname: bankAccount?.tpcbname,
        tpcbnum: bankAccount?.tpcbnum,
        tpcbtype: bankAccount?.tpcbtype,
        tpiban: bankAccount?.tpiban,
      });

      setState((prev: any) => ({
        ...prev,
        bankAccount: data,
      }));
    }
  }, [data, form]);

  return (
    <DF.Provider pagcode="TabTPBankAccount">
      <Spin spinning={isFetching}>
        <Row>
          <Col span={24}>
            <Card size="small" type="inner" title="bank-information" bordered>
              <Row gutter={[0, 0]}>
                <Col xs={24}>
                  <FormInput name="tppaymodein" rules={[{ required: true }]}>
                    <ParListSelect parcode="PAYMODEIN" />
                  </FormInput>
                </Col>
                <Col xs={24}>
                  <FormInput name="tppaymodeout" rules={[{ required: true }]}>
                    <ParListSelect parcode="PAYMODEOUT" />
                  </FormInput>
                </Col>
                <Col xs={16}>
                  <FormInput name="tpiban" rules={[{ required: true }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
                <Col xs={8}>
                  <FormInput name="tpbic" rules={[{ required: true }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
                <Col xs={16}>
                  <FormInput name="tpbankname" rules={[{ required: true }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
                <Col xs={8}>
                  <FormInput name="tpcbtype" rules={[{ required: true }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
              </Row>
              <Row gutter={[0, 0]}>
                <Col xs={24}>
                  <FormInput name="tpcbnum" rules={[{ required: false }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
                <Col xs={24}>
                  <FormInput name="tpcbdate" rules={[{ required: false }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
                <Col xs={16}>
                  <FormInput name="tpcbname" rules={[{ required: false }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
                <Col xs={8}>
                  <FormInput name="tpcbkey" rules={[{ required: false }]}>
                    <Input></Input>
                  </FormInput>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabTPBankAccount;
